<div class="query-editor">
  <mat-form-field appearance="outline" class="inptname">
    <mat-label>Name</mat-label>
    <input
      class="query-name"
      matInput
      [formControl]="namequery"
      autocomplete="off"
    />
    <ng-container *ngIf="!isAiGenerated">
      <mat-icon class="query-import" [matMenuTriggerFor]="menuImport"
        >more_vert</mat-icon
      >
      <mat-menu #menuImport="matMenu">
        <button mat-menu-item *ngIf="!data" (click)="fileInput.click()">
          Import query from file
        </button>
        <button mat-menu-item [disabled]="!hasTerms" (click)="iExport()">
          Export query to json file
        </button>
        <input
          #fileInput
          class="inptfile"
          type="file"
          accept=".json"
          value=""
          (click)="fileInput.value = null"
          (change)="importQuery($event)"
        />
      </mat-menu>
    </ng-container>
  </mat-form-field>
  <mat-form-field *ngIf="!isAiGenerated" appearance="outline" class="inptname">
    <mat-label>Collection</mat-label>
    <mat-select [(ngModel)]="selectedCollection" multiple>
      <mat-option
        *ngFor="let collection of queryApi.querys"
        [value]="collection.uid"
        [disabled]="
          collection.content.length >=
          featureFlagsService.featureFlags.queriesPerCollectionsLimit
        "
      >
        {{ collection.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" class="inptname">
    <mat-label>Description</mat-label>
    <textarea
      #message
      matInput
      [formControl]="descriptionQuery"
      maxlength="200"
      class="query-description"
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
    ></textarea>
    <mat-hint align="end">{{ message.value.length }} / 200</mat-hint>
  </mat-form-field>
  <div mat-dialog-content>
    <div class="query-bello">
      <app-query-builder
        [tree]="tree"
        [editing]="true"
        [allowGroups]="true"
        [fields]="pickerFields"
        [artifacts]="(artifacts$ | async) ?? []"
        naming="position"
        panelClass="setup-overlay-panel"
        (treeChange)="setTree($event)"
      ></app-query-builder>
    </div>
  </div>
  <div mat-dialog-actions>
    <ng-container *ngIf="idelete == 0">
      <button
        *ngIf="data && !isAiGenerated"
        mat-raised-button
        color="warn"
        class="btndele"
        [class.delete-warning]="isButtonActive"
        (mouseover)="isButtonActive = true"
        (mouseout)="isButtonActive = false"
        (click)="iDelete()"
      >
        <mat-icon>delete</mat-icon>
        <span>delete</span>
      </button>
      <button
        *ngIf="!isAiGenerated && !data"
        mat-raised-button
        color="primary"
        class="btnsave"
        (click)="tree = { operator: 'and', filters: [], groups: [] }"
        [class.hide]="idelete"
      >
        <mat-icon>create_new_folder</mat-icon>
        <span>new</span>
      </button>
      <button
        *ngIf="!isAiGenerated && data"
        mat-raised-button
        color="primary"
        class="btnsave"
        (click)="iSave(false)"
        [disabled]="!hasTerms"
        [class.hide]="idelete"
      >
        <mat-icon>file_copy</mat-icon>
        <span>duplicate</span>
      </button>
      <button
        *ngIf="!isAiGenerated && data"
        mat-raised-button
        color="primary"
        class="btnsave"
        (click)="iSave(true)"
        [disabled]="!hasTerms"
        [class.hide]="idelete"
        [class.save-active]="hasTerms"
      >
        <mat-icon>save_alt</mat-icon>
        <span>save</span>
      </button>
      <button
        *ngIf="!isAiGenerated && !data"
        mat-raised-button
        color="primary"
        class="btnsave"
        (click)="iSave(false)"
        [disabled]="!hasTerms"
        [class.hide]="idelete"
        [class.save-active]="hasTerms"
      >
        <mat-icon>save_alt</mat-icon>
        <span>save</span>
      </button>
      <button
        *ngIf="isAiGenerated"
        mat-raised-button
        color="accent"
        class="btnsave btnsearch"
        (click)="iSearch()"
        [disabled]="!hasTerms"
        [class.hide]="idelete"
      >
        <mat-icon>search</mat-icon>
        <span>search</span>
      </button>
    </ng-container>
  </div>
</div>
